import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
  import router from "@/router";
  import store from "@/store";
  import SwitchComponent from "@/components/ui/SwitchComponent.vue";
  import { UserInterface } from "@/types/UserInterface";
  import { EstateInterface } from "@/types/EstateInterface";
  import { StageInterface } from "@/types/StageInterface";
  import { UserRoles } from "@/enums/UserRoles";
  import { getFirstLastName } from "@/helpers/user";
  import { getStageStatusClass } from "@/helpers/status";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminStage',
  setup(__props, { expose: __expose }) {
  __expose();

  const userId = router.currentRoute.value.params.userId;
  const estateId = router.currentRoute.value.params.estateId;
  const stageId = router.currentRoute.value.params.stageId;
  const user = ref<UserInterface | null>(null);
  const estate = ref<EstateInterface | null>(null);
  const stage = ref<StageInterface | null>(null);
  const tabs = [{ label: "lots" }, { label: "map" }];
  const currentTab = ref(
    tabs.find((label) =>
      router.currentRoute.value.fullPath.includes(label.label)
    )
  );

  function toTab(tab: string) {
    if (currentTab.value.label !== tab) {
      router.push(
        router.currentRoute.value.fullPath.replace(currentTab.value.label, tab)
      );
    }
  }

  onMounted(() => {
    store.dispatch("user/getUser", userId).then((res) => {
      user.value = res.data;
    });
    store.dispatch("estate/getEstate", estateId).then((res) => {
      estate.value = res.data;
    });
    store.dispatch("stage/getStage", stageId).then((res) => {
      stage.value = res.data;
    });
  });

const __returned__ = { userId, estateId, stageId, user, estate, stage, tabs, currentTab, toTab, onMounted, ref, get router() { return router }, get store() { return store }, SwitchComponent, get UserInterface() { return UserInterface }, get EstateInterface() { return EstateInterface }, get StageInterface() { return StageInterface }, get UserRoles() { return UserRoles }, get getFirstLastName() { return getFirstLastName }, get getStageStatusClass() { return getStageStatusClass } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})